/** @format */

import { HomrGTGTContent, HomrScheduleContent } from '@shared/data-access/interfaces';
import { createAction, props } from '@ngrx/store';

export const setHomrScheduleContent = createAction(
	'[Homr] Set Homr Schedule Content',
	props<{ homrScheduleContent: HomrScheduleContent }>()
);

export const setHomrGTGTContent = createAction(
	'[Homr] Set Homr GTGT Content',
	props<{ homrGTGTContent: HomrGTGTContent }>()
);
